/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';

import useDataFetchIndicator from '../useDataFetchIndicator';

type HookProps = { api: vp.Api };
type HookTuple = [leadDetails: vp.LeadsDetailsResponse, fetchData: (leadId: string) => void];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchLead: ApiHook = ({ api }) => {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  const [leadId, setLeadId] = useState('');
  const [leadDetails, setLeadDetails] = useState<vp.LeadsDetailsResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    const loadData = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');

      const res = await api.fetchLeadsDetails({ LeadID: leadId }, source);

      if (res) {
        setLeadDetails(res);
      }

      setDataFetchingInfo(false);
    };

    if (leadId) void loadData();

    return () => {
      source.cancel();
    };
  }, [leadId]);

  return [leadDetails, (_leadId: string) => setLeadId(_leadId)];
};
export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchLead);
